import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { Sidebar } from './shared/sidebar/sidebar';
import { SessionService } from './core/services/session-service';
import { LoadingIndicator } from './shared/loading-indicator/loading-indicator';
import { NotificationToast } from './shared/notification-toast/notification-toast';
import { filter } from 'rxjs';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, Sidebar, LoadingIndicator, NotificationToast],
  templateUrl: './app.html',
  styleUrl: './app.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class App {
  private sessionService = inject(SessionService);
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private cdr = inject(ChangeDetectorRef);

  /**
   * True on routes that must render without the admin sidebar.
   *
   * The dealer-facing receipt can be opened in a browser where an admin is already logged
   * in, and it would otherwise appear wrapped in the admin navigation.
   */
  protected isFullBleed = false;

  constructor() {
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
      let deepest = this.route.snapshot;
      while (deepest.firstChild) deepest = deepest.firstChild;
      this.isFullBleed = deepest.data['fullBleed'] === true;
      this.cdr.markForCheck();
    });
  }

  get isLoggedIn() {
    return this.sessionService.isLoggedIn;
  }
}
